const fuseDark = {
	50: '#e3e6e8',
	100: '#bac0c5',
	200: '#8c969f',
	300: '#EDF0F2',
	// 300: '#5e6c78', prev gray
	400: '#3c4d5b',
	// 500: '#e73859', prev pink
	500: '#1F1E30',
	600: '#162838',
	700: '#343342',
	// 700: '#aa0027', prev dark red
	800: '#0e1c28',
	900: '#08111b',
	A100: '#5b9aff',
	A200: '#287bff',
	A400: '#005ef4',
	A700: '#0054da'
};

export default fuseDark;
